var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#shop_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "inherit",
  fillRule: "evenodd",
  d: "M24 10.971v-.685c0-.568-.448-1.029-1-1.029h-2.806l-4.449-6.292a1.31 1.31 0 0 0-1.862-.303 1.397 1.397 0 0 0-.295 1.916l3.309 4.68H7.103l3.309-4.68a1.397 1.397 0 0 0-.294-1.916 1.31 1.31 0 0 0-1.863.303l-4.45 6.292H1c-.552 0-1 .46-1 1.029v.685C0 11.54.448 12 1 12h.333l1.088 7.834c.141 1.013.985 1.766 1.98 1.766H19.6c.995 0 1.839-.753 1.98-1.766L22.667 12H23c.552 0 1-.46 1-1.029m-11 2.057v4.8c0 .569-.448 1.03-1 1.03s-1-.461-1-1.03v-4.8c0-.568.448-1.028 1-1.028s1 .46 1 1.028m4.666 4.8v-4.8c0-.568-.447-1.028-1-1.028s-1 .46-1 1.028v4.8c0 .569.448 1.03 1 1.03.553 0 1-.461 1-1.03m-9.332-4.8v4.8c0 .569-.448 1.03-1 1.03-.553 0-1-.461-1-1.03v-4.8c0-.568.447-1.028 1-1.028s1 .46 1 1.028",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "shop_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgShop;